import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=03bfbf1e&scoped=true"
import script from "./ImgPreview.vue?vue&type=script&lang=js"
export * from "./ImgPreview.vue?vue&type=script&lang=js"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=03bfbf1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bfbf1e",
  null
  
)

export default component.exports